import { commonjsGlobal as g } from "./index135.mjs";
import { __module as h } from "./index170.mjs";
h.exports;
(function(e) {
  (function(b, p, j) {
    function m(u) {
      var o = this;
      o.next = function() {
        var f = o.w, t = o.X, r = o.i, n, i;
        return o.w = f = f + 1640531527 | 0, i = t[r + 34 & 127], n = t[r = r + 1 & 127], i ^= i << 13, n ^= n << 17, i ^= i >>> 15, n ^= n >>> 12, i = t[r] = i ^ n, o.i = r, i + (f ^ f >>> 16) | 0;
      };
      function a(f, t) {
        var r, n, i, x, l, c = [], w = 128;
        for (t === (t | 0) ? (n = t, t = null) : (t = t + "\0", n = 0, w = Math.max(w, t.length)), i = 0, x = -32; x < w; ++x)
          t && (n ^= t.charCodeAt((x + 32) % t.length)), x === 0 && (l = n), n ^= n << 10, n ^= n >>> 15, n ^= n << 4, n ^= n >>> 13, x >= 0 && (l = l + 1640531527 | 0, r = c[x & 127] ^= n + l, i = r == 0 ? i + 1 : 0);
        for (i >= 128 && (c[(t && t.length || 0) & 127] = -1), i = 127, x = 4 * 128; x > 0; --x)
          n = c[i + 34 & 127], r = c[i = i + 1 & 127], n ^= n << 13, r ^= r << 17, n ^= n >>> 15, r ^= r >>> 12, c[i] = n ^ r;
        f.w = l, f.X = c, f.i = i;
      }
      a(o, u);
    }
    function v(u, o) {
      return o.i = u.i, o.w = u.w, o.X = u.X.slice(), o;
    }
    function X(u, o) {
      u == null && (u = +/* @__PURE__ */ new Date());
      var a = new m(u), f = o && o.state, t = function() {
        return (a.next() >>> 0) / 4294967296;
      };
      return t.double = function() {
        do
          var r = a.next() >>> 11, n = (a.next() >>> 0) / 4294967296, i = (r + n) / (1 << 21);
        while (i === 0);
        return i;
      }, t.int32 = a.next, t.quick = t, f && (f.X && v(f, a), t.state = function() {
        return v(a, {});
      }), t;
    }
    p && p.exports ? p.exports = X : this.xor4096 = X;
  })(
    g,
    // window object or global
    e
  );
})(h);
var k = h.exports;
export {
  k as x
};
